let _coordinator = null;
export function _setRecordingCoordinator(coordinator) {
  _coordinator = coordinator;
}
export const breezeEngineRecording = {
  exportRecording: conversationId => {
    var _coordinator$exportRe, _coordinator2;
    return (_coordinator$exportRe = (_coordinator2 = _coordinator) === null || _coordinator2 === void 0 ? void 0 : _coordinator2.exportRecording(conversationId)) !== null && _coordinator$exportRe !== void 0 ? _coordinator$exportRe : null;
  },
  downloadRecording: conversationId => {
    var _coordinator3;
    (_coordinator3 = _coordinator) === null || _coordinator3 === void 0 || _coordinator3.downloadRecording(conversationId);
  },
  resetRecording: conversationId => {
    var _coordinator4;
    (_coordinator4 = _coordinator) === null || _coordinator4 === void 0 || _coordinator4.resetRecording(conversationId);
  },
  hasRecording: conversationId => {
    var _coordinator$hasRecor, _coordinator5;
    return (_coordinator$hasRecor = (_coordinator5 = _coordinator) === null || _coordinator5 === void 0 ? void 0 : _coordinator5.hasRecording(conversationId)) !== null && _coordinator$hasRecor !== void 0 ? _coordinator$hasRecor : false;
  }
};
export function useRecordingApi() {
  return breezeEngineRecording;
}